import { definePreference, usePreference } from '@if/core/storage'
import { useCan, useIfUser } from '@if/mui'
import { access } from '@src/access'

const hideUnreadMessagePopupsPreference = (userId: string) =>
  definePreference<boolean>({ key: `hide-unread-message-popups:${userId}`, scope: 'device' })

/** Stand-in key while the user is still resolving — nothing reads a pop-up state then. */
const UNKNOWN_USER_ID = 'unknown'

export const useCanOptOutOfUnreadMessagePopups = () => useCan(access.unreadMessagePopupOptOut)
export const useHideUnreadMessagePopups = (): [boolean, (hidden: boolean) => void] => {
  const user = useIfUser()
  const canOptOut = useCanOptOutOfUnreadMessagePopups()
  const [stored, setHidden] = usePreference(hideUnreadMessagePopupsPreference(user?.id ?? UNKNOWN_USER_ID))
  return [canOptOut && (stored ?? false), setHidden]
}
const dismissedCreditApplicationIds = new Set<string>()

export const isUnreadMessagePopupDismissed = (creditApplicationId: string) =>
  dismissedCreditApplicationIds.has(creditApplicationId)

export const markUnreadMessagePopupDismissed = (creditApplicationId: string) => {
  dismissedCreditApplicationIds.add(creditApplicationId)
}

/** Re-arms the pop-up for an application once its messages are all read. */
export const clearUnreadMessagePopupDismissal = (creditApplicationId: string) => {
  dismissedCreditApplicationIds.delete(creditApplicationId)
}
